<template>
    <KpIcon
        v-if="addressRecord?.type === 'location'"
        icon-cls="address"
        :size="size"
        :color="iconColor"
        :title="$t('location')"
    />
    <KpIcon
        v-else-if="addressRecord?.type === 'event_organizer'"
        icon-cls="speaker"
        :color="iconColor"
        :size="size"
        :title="$t('event_organizer')"
    />
    <KpIcon v-else icon-cls="world" :color="iconColor" :size="size" :title="$t('address')" />
</template>

<script lang="ts" setup>
import { Address } from '@/models/Address';
import { EventOrganizer } from '@/models/EventOrganizer';
import { Location } from '@/models/Location';
import { computed } from 'vue';

const props = defineProps<{
    addressRecord: Address | EventOrganizer | Location | null;
    size?: number | string;
}>();

const iconColor = computed(() =>
    props.addressRecord?.is_visible && props.addressRecord?.status === 'in_union' ? 'ok' : 'grey',
);
</script>
